export const amenities = {
  hasParking: {
    name: "Parcheggio",
    icon: "parking",
    visible: true,
  },
  hasPetsAllowed: {
    name: "Animali ammessi",
    icon: "pets",
    visible: true,
  },
  hasRestaurant: {
    name: "Ristorante",
    icon: "restaurant",
    visible: true,
  },
  hasAccessibility: {
    name: "Accessibilità",
    icon: "accessibility",
    visible: true,
  },
  hasChildrenServices: {
    name: "Servizi per bambini",
    icon: "children_services",
    visible: true,
  },
  hasKitchen: {
    name: "Cucina",
    icon: "cutlery",
    visible: true,
  },
  hasPool: {
    name: "Piscina",
    icon: "pool",
    visible: true,
  },
  hasSpa: {
    name: "Spa e Wellness",
    icon: "spa",
    visible: true,
  },
  hasBusinessCenter: {
    name: "Business Center",
    icon: "business_center",
    visible: true,
  },
  hasChargingStation: {
    name: "Stazione di ricarica",
    icon: "charging",
    visible: true,
  },
  hasReceptionOpen24h: {
    name: "Reception aperta h24",
    icon: "symbol_vv",
    visible: true,
  },
  hasAirportShuttle: {
    name: "Navetta aeroportuale",
    icon: "symbol_vv",
    visible: true,
  },
  hasBeach: {
    name: "Spiaggia",
    icon: "symbol_vv",
    visible: true,
  },
  hasFreeWifi: {
    name: "Connessione WIFI gratuita",
    icon: "symbol_vv",
    visible: true,
  },
  hasGym: {
    name: "Palestra",
    icon: "symbol_vv",
    visible: true,
  },
  hasTravelProud: {
    name: "LGBTQ friendly",
    icon: "symbol_vv",
    visible: true,
  },
}

export function get_amenities(key) {
  // try V2 syntax as is (es "hasChargingStation")
  if (amenities[key] !== undefined) return amenities[key]

  // try V3 syntax as is (es "has_charging_station")
  let key_v3 = key
    .split('_')
    .map((word, index) => {
      if (index === 0) return word
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
  if (amenities[key_v3] !== undefined) return amenities[key_v3]

  // return key as fallback with placeholder icon
  return {
    name: key,
    icon: "symbol_vv",
  }
}